import * as React from "react";

import "./information-badge.scss";

import {cs} from "@Common/react/chain-services";

import {Tooltip2} from "../tooltip-2/tooltip-2";

/**
 *
 * @param height
 * @param getTooltip
 * @param direction east | west | ...
 * @param xdQaName
 * @constructor
 */
export const InformationBadge = ({height = 23, icon = "fa-info", getTooltip=undefined, direction=undefined, xdQaName=undefined}) => cs(
    ["tooltip", (_, next) => !getTooltip ? next() : Tooltip2({
        getMessage: getTooltip,
        direction,
        next,
    })],
    ({tooltip}) => (
        <div
            className="information-badge information-badge-53s"
            ref={tooltip?.ref}
            style={{height, paddingTop: (height - 12) / 2 - 1}}
            onClick={tooltip?.onClick}
            onMouseEnter={tooltip?.onMouseEnter}
            onMouseLeave={tooltip?.onMouseLeave}
        >
            {tooltip?.render()}
            <div className="circle">
                <i className={"fa " + icon} xd-qa-type="icon" xd-qa-name={xdQaName}/>
            </div>
        </div>
    ),
);
